import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { render, createPortal } from 'react-dom';
import { Provider } from 'react-redux';
import appStore from './store';
import HeaderFeature from './components/Header';
import PurchaseSidebar from './components/PurchaseSidebar';
const ModulesWithStore = () => {
    const headerElement = document.getElementById('header');
    const sidebarElement = document.getElementById('react-purchase-sidebar');
    return (_jsxs(Provider, Object.assign({ store: appStore }, { children: [headerElement ? createPortal(_jsx(HeaderFeature, {}), headerElement) : null, sidebarElement ? createPortal(_jsx(PurchaseSidebar, {}), sidebarElement) : null] })));
};
export const renderModulesWithStore = () => {
    setTimeout(() => {
        render(_jsx(ModulesWithStore, {}), document.getElementById('modules-with-store'));
    }, 200);
};
